import commonDialogueNew from './commonDialogueNew';

commonDialogueNew.install = (Vue) => {
  Vue.component(commonDialogueNew.name, commonDialogueNew);
  // Vue实例构造函数
  const Comp = Vue.extend(commonDialogueNew);

  Vue.prototype.$myDialog2 = props => new Promise((resolve) => {
    const compInstance = new Comp({
      propsData: props,
    }).$mount();
    document.body.appendChild(compInstance.$el);
    compInstance.isShow = true;

    compInstance.$on('confirm', () => {
      resolve(true);
      document.body.removeChild(compInstance.$el);
      compInstance.$destroy();
    });

    compInstance.$on('cancel', () => {
      resolve(false);
      document.body.removeChild(compInstance.$el);
      compInstance.$destroy();
    });
  });
};

export default commonDialogueNew;
